export default {
    LAST_HOUR: 1,
    TODAY: 2,
    YESTERDAY: 3,
    LAST_7_DAYS: 4,
    LAST_30_DAYS: 5,
    ALL_TIME: 6,
    PERIOD: 7
};
